
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 639.4 447.7"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M0 0h639.4v447.7H0z"}})]),_c('path',{attrs:{"d":"M626.2 70c-7.4-27.4-29-49-56.3-56.4C519.8 0 319.7 0 319.7 0S119.6 0 69.5 13.2c-26.9 7.4-49 29.5-56.4 56.9C0 120.1 0 223.8 0 223.8s0 104.3 13.2 153.8c7.4 27.4 29 49 56.4 56.4 50.6 13.7 250.2 13.7 250.2 13.7s200.1 0 250.2-13.2c27.4-7.4 49-29 56.4-56.4 13.2-50 13.2-153.8 13.2-153.8s.3-104.2-13.4-154.3M256 319.7V128l166.4 95.9L256 319.7z"}})])
          )
        }
      }
    